// extracted by mini-css-extract-plugin
module.exports = {"dekDefaultLocale":"ArticleDek_dekDefaultLocale__9CuTg"};